import React, { Component } from 'react';
import { connect } from 'react-redux';
import style from './style.css';
import CSSModule from 'react-css-modules';
import { changeClassSingupStatus } from '../../actions';
import moment from 'moment';
import Button from '../../component/button';
import Title from '../../component/title';
import { Modal } from 'antd';

import { browserHistory } from 'react-router';

class Board extends Component  {

    constructor(props) {
        super(props);

        this.state = {
            data : props.data
        }

        this.actionIndex = null;
    }

    changeStatus(object, action) {

        const callback = (res) => {
            this.state.data.students[this.actionIndex].status = res.status;
            this.setState(this.state.data);
            this.actionIndex = null;
        }

        this.props.changeStatus(object.signUps_id, action, callback);
    }

    cancelFixed(object) {

        const callback = (res) => {
            if( res.count ) {
                alert("取消報名成功！");
                location.reload();
            }
        }

        const r = confirm("取消報名後，將釋放名額給其他學生報名");
        if(r) this.props.cancelFixed(object.signUps_id, callback);
    }

    render() {
        const { content, type, students, student_id, class_lesson, status }  = this.state.data;
        const dateObject = {
                date: moment(class_lesson.date).format("MM/DD dddd"),
                start: moment(class_lesson.start_time).format("HH:mm"),
                end: moment(class_lesson.end_time).format("HH:mm")
            }
        const pastClass = moment(class_lesson.end_time).diff(moment()) < 0 ? true : false;

        const renderInteraction = (object, index) => {

            const handleClick = (action) => {
                
                if( this.actionIndex !== index ) this.changeStatus(object, action);
                this.actionIndex = index;
            }

            switch(object.status) {
                case 'non-arrival':
                    return pastClass === true ? 
                        <p styleName="warning">曠課 </p> :
                        <Button styleName="board-button" onClick={handleClick.bind(this, "absence")}>請假一次</Button>
                case 'arrival': 
                    return <p styleName="warning">已過上課時間 </p>
                case 'absence':
                    return <Button styleName="board-button" onClick={handleClick.bind(this, "non-arrival")}>取消請假恢復上課</Button>;
                default:
                    return false;
            }

        }

        return(
            <div styleName="body">
                {students.map((object, index) => {
                    const typeName = object.type === 'single' ? '單堂課' : '固定生';
                    return(
                        <div styleName="boardBlock" key={index}>
                            <p>{ `${dateObject.date} ${dateObject.start} - ${dateObject.end}` }</p>
                            <p>{ content }</p>
                            <p>報名方式：{ typeName }</p>
                            <p>學生：{ object.student_name }</p>
                            { renderInteraction(object, index) }
                            { object.type === 'fixed' && <Button styleName="board-button" onClick={this.cancelFixed.bind(this, object)}>取消報名固定生</Button> }
                        </div>
                    );
                })}
            </div>
            
        );
    }
}

export default CSSModule(Board,style,{allowMultiple:true});


/** WEBPACK FOOTER **
 ** ./src/container/applyMain/board.js
 **/